
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[courseId]/curriculum",
      function () {
        return require("private-next-pages/courses/[courseId]/curriculum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[courseId]/curriculum"])
      });
    }
  